export default __webpack_public_path__ + "static/media/undraw_File_searching_re_3evy.222f6df2.png";